import { client } from "api";
import { Company } from "models/Company";
import { CompanyComment } from "models/CompanyComment";

export type CreateCommentRequest = { companyId: Company["id"] } & Pick<CompanyComment, "commentText" | "important">;

export type CreateCommentResponse = CompanyComment[];

export const createComment = ({ companyId, commentText, important }: CreateCommentRequest) =>
  client.post<CreateCommentResponse>(`/company/${companyId}/comments`, { commentText, important }).then((res) => res.data);
